const separator = '._'

export const extractKey = (combinedKey) => combinedKey.split(separator);

export const doCombineKey = (parentKey = '', currentKey = '') => parentKey.length > 0 ? (parentKey + separator + currentKey) : currentKey;

export const isPropValid = (obj, prop) => obj[prop] !== undefined && obj[prop] !== null;

export const rewriteCombinedProps = (props) => props.split(separator).join('.');

/**
 * 
 * @param {any} target 
 * @returns {boolean}
 */
export const canWrap = (target) => {
    if (target !== null && typeof target === 'object') {
        return Object.prototype.toString.call(target) === '[object Object]';
    }
    return target !== null
        && typeof target === 'object'
        && !Array.isArray(target)
        && !(target instanceof Date)
        && !(target instanceof Set)
        && !(target instanceof Map)
        && !(target instanceof WeakMap)
        && !(target instanceof WeakSet)
        && !(target instanceof window.HTMLElement)
        && !(target instanceof Node)
        && !(target instanceof window.Element)
}

export const generateId = (() => {
    let counter = 0;
    return () => counter++;
})();

export const transformObjectToFlat = (obj) => {
    const loop = (objIn, flatObj, propKeys = []) => {
        for (let k in objIn) {
            const cloneKeys = [...propKeys];
            cloneKeys.push(k);
            const target = objIn[k];
            if (canWrap(target)) {
                loop(target, flatObj, cloneKeys);
            } else {
                flatObj[cloneKeys.join('.')] = objIn[k];
            }
        }
        return flatObj;
    }
    return loop(obj, {});
}


export const isPrimitive = (target) => target == Object(target)

export const isArray = (target) => Array.isArray(target);

export const isObject = (target) => {
    return target !== null
        && typeof target === 'object'
        && !Array.isArray(target)
        && !(target instanceof Date)
        && !(target instanceof Set)
        && !(target instanceof Map)
        && !(target instanceof WeakMap)
        && !(target instanceof WeakSet)
}

export const isFunction = target => typeof target === 'function'

export const generateString = (() => {
    const characters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz';
    const existed = new Set();
    return (length, prefix = '') => {
        let result = '';
        do {
            const charactersLength = characters.length;
            for (let i = 0; i < length; i++) {
                result += characters.charAt(Math.floor(Math.random() * charactersLength));
            }
            if (!existed.has(result)) {
                existed.add(result);
                break;
            }
        } while (true)
        return (prefix + result).trim();
    }
})();


export const isEqual = (value1, value2) => {
    return value1 === value2;
}

export const isContainSpecialChar = (str) => /[!@#$%^&*()_+\-=\[\]{};':"\\|,<>\/?]+/g.test(str)
